import { Components, Theme } from '@mui/material'

export const MuiPopover: Components<Omit<Theme, 'components'>>['MuiPopover'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      padding: theme.spacing(1),
    }),
  },
}
